import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter, Routes, Route } from "react-router"

import "./index.css"
import "bulma/css/bulma.min.css"

import App from "./App"
import Article from "./components/Article"
import MainLayout from "./components/MainLayout"

import reportWebVitals from "./reportWebVitals"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <MainLayout>
      <Routes>
        <Route index element={<App />} />
        <Route path="article/:folder/:hash" element={<Article />} />
      </Routes>
    </MainLayout>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
